const VARIABLES = {
    palette: {
        primary_light: '#2D3749',
        primary_color: '#151F2F',
        primary_dark: '#10151F',
        secondary_light: '#BC65F1',
        secondary_color: '#8338EA',
        secondary_dark: '#5A00AA',
        success_light: '#65EAB8',
        success_color: '#25B889',
        success_dark: '#00865B',
        warning_light: '#FFDD61',
        warning_color: '#E4A824',
        warning_dark: '#CD9721',
        error_light: '#FF7266',
        error_color: '#EC3B3B',
        error_dark: '#B20013',
        background_light: '#F5F6FC',
        background_color: '#E5E8F7',
        background_dark: '#D7DBF1',
        content_light: '#BCC6DC',
        content_color: '#7987A4',
        content_dark: '#4C5A75',
        auxiliar_light: '#9856FF',
        auxiliar_color: '#5F24DB',
        auxiliar_dark: '#4A2A8E',
        normal_green: '#68758E'
    },
    menu: {
        width_expanded: '14rem',
        width_collapsed: '3.5rem',
        divider: {
            width_inside_dropdown: '9.5rem'
        }
    },
    input: {
        component_width: '18.5rem'
    },
    screen_header: {
        height: '4.5rem'
    },
    drawer: {
        width: '32rem'
    }
};

export default VARIABLES;
